import React from "react";
import { NavLink } from "react-router-dom";
function Menu() {
  return (
    <div className="col-lg-6 col-12 d-none d-lg-block">
      <div className="menu">
        <ul>
          <li className="active">
            <NavLink to="/">صفحه اصلی</NavLink>
          </li>
          <li>
            <NavLink to="blog">وبلاگ</NavLink>
          </li>
          <li className="menu">
            <NavLink to="menu">منو</NavLink>
          </li>
          <li>
            <NavLink to="contact-us">تماس با ما</NavLink>
          </li>
          <li>
            <NavLink to="about-us">درباره ما</NavLink>
          </li>
          <li>
            <a href="https://baghban.restaurant/extra/360/" target="_blank">
              تور مجازی
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Menu;
